import { useSelector } from 'react-redux'

import useAgencyProviderDeadlineGroup, {
  useAgencyProviderDeadlineGroupForm,
} from '@hooks/useAgencyProviderDeadlineGroup'
import useAgencyProvider from '@hooks/useAgencyProvider'
import useAgencyProviders from '@hooks/useAgencyProviders'
import useProviderDeadlineGroups from '@hooks/useProviderDeadlineGroups'

const handleChangeProvider = (providerId, setEntityState) => {
  setEntityState({
    provider_id: providerId,
    provider_deadline_group_id: null,
  })
}

const useCreateOrEditAgencyProviderDeadlineGroupModal = (agencyProviderDeadlineGroup = {}) => {
  const { providerDeadlineGroups, providers, services } = useSelector(reduxState => reduxState.entities)

  const {
    entityState,
    entityState: {
      provider_deadline_group_id,
      provider_id,
    },
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = useAgencyProviderDeadlineGroupForm(agencyProviderDeadlineGroup, { validateOn: 'change' })

  const { filteredProviderDeadlineGroups } = useProviderDeadlineGroups({
    filters: { provider_id },
    performHttpRequests: !!provider_id,
  })

  const { uniqueProviderIds } = useAgencyProviders({
    filters: {
      agency_id: agencyProviderDeadlineGroup.agency_id,
    },
    performHttpRequests: !!agencyProviderDeadlineGroup.agency_id,
  })

  const {
    callbacks: { createOrEditAgencyProvider },
  } = useAgencyProvider({ agency_id: agencyProviderDeadlineGroup.agency_id })

  const providersList = uniqueProviderIds.map(id => providers[id])

  const selectedProviderDeadlineGroup = providerDeadlineGroups[provider_deadline_group_id] || {}
  const {
    deadlines = {},
  } = selectedProviderDeadlineGroup

  const {
    callbacks: {
      createAgencyProviderDeadlineGroup,
      deleteAgencyProviderDeadlineGroup,
      updateAgencyProviderDeadlineGroup,
    },
    creating,
    deleting,
    updating,
  } = useAgencyProviderDeadlineGroup(agencyProviderDeadlineGroup)

  return {
    callbacks: {
      createAgencyProviderDeadlineGroup,
      createOrEditAgencyProvider,
      deleteAgencyProviderDeadlineGroup,
      handleChangeProvider: providerId => handleChangeProvider(providerId, setEntityState),
      updateAgencyProviderDeadlineGroup,
    },
    creating,
    deadlines,
    deadlinesCount: Object.keys(deadlines).length,
    deleting,
    entityState,
    errors,
    filteredProviderDeadlineGroups,
    handlers,
    hasDeadlines: !!Object.keys(deadlines).length,
    providersList,
    saveEnabled,
    services,
    updating,
  }
}

export default useCreateOrEditAgencyProviderDeadlineGroupModal
